export const paymentGateways = {
  name: 'Payment Gateways',
  edit_title: 'Edit Payment Gateway',
  fields: {
    code: 'Code',
    name: 'Name',
    is_active: 'Active',
    is_configured: 'Configured',
    supports_tokenization: 'Savable',
    env_var_prefix: 'Env Var Prefix',
    config: 'Configuration',
    created_at: 'Created At',
    updated_at: 'Updated At',
  },
  status: {
    configured: 'Configured',
    not_configured: 'Not Configured',
  },
  sections: {
    basic_settings: 'Basic Settings',
    gateway_info: 'Gateway Information',
    environment: 'Environment Configuration',
  },
  hints: {
    configured: 'Gateway has all required environment variables configured',
    not_configured: 'Missing required environment variables',
    not_configured_warning: 'This gateway is not fully configured. Check that all required environment variables are set.',
    is_active: 'When disabled, payment methods using this gateway will not be available',
    edit_info: 'Gateway settings. Sensitive configuration (API keys, secrets) must be set as environment variables.',
    environment_vars: 'The following environment variables must be configured for this gateway:',
    no_env_prefix: 'No environment variable prefix defined',
  },
};

export const paymentGatewaysResource = {
  ...paymentGateways,
};
